export default __webpack_public_path__ + "static/media/filter.bec70aff.svg";